import CenteredHero from "@/components/CenteredHero"
import GeneralLayout from "@/layouts/General"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import ContentMAPI from "@/app/api/content-management/content-management"
import { useGlobalContext } from "@/global/GlobalContext"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
import { LoadButton } from "@/components/Button"
const contentMApi = new ContentMAPI()

const Philanthropy = () => {
  const { notifyError } = useGlobalContext()
  const [philanthropy, setPhilanthropy] = useState(null)
  const [philanthropyGalleries, setGalleries] = useState([])
  const [onReq, setOnReq] = useState(true)
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const hideLoadMoreBtn = useRef(true)

  useEffect(() => {
    loadPhilanthropy()
  }, [])

  useEffect(() => {
    if (philanthropy) loadGalleries()
  }, [philanthropy])

  useEffect(() => {
    if (page > 1) loadGalleries(page)
  }, [page])

  const loadMoreGalleries = () => {
    setPage(page + 1)
  }

  // API request
  const loadPhilanthropy = async () => {
    setOnReq(true)
    try {
      const { data } = await contentMApi.getPhilanthropy()
      setPhilanthropy(data.data)
    } catch (err) {
      notifyError(err.response.data.message)
      navigate("/coming-soon")
    }
  }

  const loadGalleries = async (page = 1) => {
    try {
      let param = {
        page: page
      }
      const { data } = await contentMApi.getPhilanthropyGalleries(philanthropy.id, param)
      hideLoadMoreBtn.current = data.data.galleries.length < 12
      if (philanthropyGalleries.length > 0) {
        setGalleries(philanthropyGalleries.concat(data.data.galleries))
      } else {
        setGalleries(data.data.galleries)
      }
    } catch (err) {
      notifyError(err.response.data.message)
      // navigate("/coming-soon")
    }
    setOnReq(false)
  }

  return (
    <>
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        {philanthropy ?
          <CenteredHero dynamicBg={philanthropy.banner} custCls="min-h-60 lg:min-h-96" />
          : <ContainerSkeleton custH="h-60 lg:h-96" />
        }
        <section className="bg-[url('/src/assets/imgs/cultural-event/section-cover.webp')] px-10 md:px-12 lg:px-20 py-12">
          <div className="text-[#6d625a] font-light mb-10">
            <div className="flex flex-col md:flex-row gap-6 sm:gap-x-10">
              <div className="w-full lg:w-[60%] text-center md:text-left px-6 md:px-0">
                {onReq ?
                  <>
                    <ContainerSkeleton custH="h-9 md:h-[60px] lg:h-[72px]" />
                    <ContainerSkeleton custH="h-[20px] md:h-[30px]" custCls=" my-5 lg:mb-8 lg:mt-10" />
                    <ContainerSkeleton custH="h-[14px] sm:h-[18px] xl:h-5 mb-1" />
                    <ContainerSkeleton custH="h-[14px] sm:h-[18px] xl:h-5 mb-1" />
                    <ContainerSkeleton custH="h-[14px] sm:h-[18px] xl:h-5 mb-1" />
                  </>
                  :
                  <>
                    <h1 className="capitalize font-agcasmlt text-4xl md:text-6xl lg:text-7xl">{philanthropy.title}</h1>
                    <p className="font-americanTC tracking-wide text-[20px] md:text-[30px] leading-[20px] md:leading-[30px] my-5 lg:mb-8 lg:mt-10">{philanthropy.quote}</p>
                    <div className="font-agcasmlt md:text-justify font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px]" dangerouslySetInnerHTML={{ __html: philanthropy.description }} />
                  </>
                }
              </div>
              <div className="w-full lg:w-[40%] h-[250px] sm:h-[350px] md:h-[500px] lg:h-[400px] overflow-hidden flex items-start justify-center">
                {/* {onReq ?
                  <ContainerSkeleton custCls="min-w-full min-h-full -mt-8" />
                  :
                  <ImageSkeleton src={philanthropy.content_side_image} custCls="min-w-full min-h-full object-cover -mt-8" />
                } */}
                <iframe className="min-w-full h-4/5 md:h-2/5 lg:h-3/4 xl:h-4/5" src="https://www.youtube.com/embed/BIZjjfKTmPA?si=q1oL2zmg7dtGdj3y" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen={true}></iframe>
              </div>
            </div>
          </div>
          <div className={philanthropyGalleries.length > 0 ?
            "grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 lg:gap-6" :
            ""}>
            {onReq ?
              Array.from({ length: 6 }, (_, i) => (
                <div key={i} className="h-40 sm:h-60 md:h-56 lg:h-80 overflow-hidden flex items-center justify-center">
                  <ContainerSkeleton custCls="min-w-full min-h-full -mt-8" />
                </div>
              ))
              :
              philanthropyGalleries.length > 0 ?
                philanthropyGalleries.map((p, i) => (
                  <div key={i} className="h-40 sm:h-60 md:h-56 lg:h-80 overflow-hidden flex items-center justify-center">
                    <ImageSkeleton src={p.photo} custCls="min-w-full min-h-full object-cover" />
                  </div>
                ))
                :
                <p className="text-center text-gray-500">No gallery available.</p>
            }
          </div>
          {!hideLoadMoreBtn.current && (
            <div className="pt-8 text-center mt-10">
              <LoadButton onClickBtn={loadMoreGalleries} />
            </div>
          )}
        </section>
      </GeneralLayout>
    </>
  )
}

export default Philanthropy